import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { ReactNode } from 'preact/compat';

import { zlExpand } from '@/components/icons';

interface HomeVideoPlayerContainerProps {
  children: ReactNode;
  miniMode?: boolean;
  onExpand?: () => void;
}

const HomeVideoPlayerContainer = ({ children, miniMode, onExpand }: HomeVideoPlayerContainerProps) => {
  return (
    <div
      data-mini-mode={miniMode}
      className={clsx(
        'group/home-player absolute bg-slate-900',
        miniMode
          ? 'bottom-5 right-5 z-10 aspect-video w-[198px] rounded shadow-2xl transition-transform group-hover/home-video-section:-translate-y-10'
          : 'inset-0',
      )}
    >
      {children}
      {miniMode && (
        <button
          type="button"
          className="preflight preflight-button absolute left-0 top-0 p-2 text-base leading-none text-white opacity-0 transition-opacity hover:text-grey-5 group-hover/home-player:opacity-100"
          title="Swap mini player content"
          onClick={onExpand}
        >
          <FontAwesomeIcon icon={zlExpand} />
          <span className="sr-only">Swap mini player content</span>
        </button>
      )}
    </div>
  );
};

export default HomeVideoPlayerContainer;
